import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Heart, Github, Twitter, Linkedin } from 'lucide-react';

const FOOTER_LINKS = {
  Product: [
    { name: 'Resume Builder', href: '/resume' },
    { name: 'Templates', href: '/templates' },
    { name: 'Features', href: '/features' },
  ],
  Resources: [
    { name: 'Resume Tips', href: '/tips' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Help Center', href: '/help' },
  ],
  Company: [
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms', href: '/terms' }
  ]
};

const socialLinks = [
  { icon: Github, href: 'https://github.com/resbuild', label: 'GitHub' },
  { icon: Twitter, href: 'https://twitter.com/resbuild', label: 'Twitter' },
  { icon: Linkedin, href: 'https://linkedin.com/company/resbuild', label: 'LinkedIn' }
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      
      <div className="container-responsive py-12 px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 group">
              <FileText className="h-6 w-6 text-teal-600 group-hover:text-teal-700 transition-colors" />
              <span className="font-bold text-xl bg-gradient-to-r from-teal-600 to-teal-500 bg-clip-text text-transparent">
                Make Resume Free
              </span>
            </Link>
            <p className="mt-4 text-sm text-gray-600">
              Create professional resumes that get you hired.
              <span className="block mt-1 font-medium text-teal-600">
                100% Free • No Sign Up • No Credit Card
              </span>
            </p>
            <div className="mt-6 flex gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-teal-600 transition-colors"
                    aria-label={social.label}
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-semibold text-gray-900 mb-3">{category}</h3>
              <ul className="space-y-2" role="list" aria-label={`${category} links`}>
                {links.map(link => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-600 hover:text-teal-600 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © {currentYear} Make Resume Free. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              Made with <Heart className="h-4 w-4 text-teal-600" /> by Make Resume Free
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}